<template>
  <button
    class="mb-2 text-2xs font-bold uppercase text-body-color"
    @click="generateAuthorityChartData(history)"
  >
    Authority History Gap
  </button>
  <div class="flex flex-col space-y-3 rounded-md">
    <router-link
      :to="{
        name: 'Carrier Brokers Show Page',
        params: { id: $store.state.show?.showBroker?.id },
      }"
      target="_blank"
      class="mb-3 text-xl text-yellow-600 underline"
    >
      {{
        capitalizeWords($store.state.show?.showBroker?.legal_name.toLowerCase())
      }}
    </router-link>
    <div class="grid grid-cols-3 gap-3">
      <div
        class="flex flex-col items-center gap-4 rounded-md border border-yellow-500 p-4 pt-6 pt-8 text-center"
      >
        <div class="text-4xl text-red-500">
          {{ gapDays.length - 1 }}
        </div>
        <h4 class="text-2xs font-bold uppercase text-body-color">
          Gaps in Authority Discovered
        </h4>
      </div>
      <div
        class="flex flex-col items-center gap-4 rounded-md border border-yellow-500 p-4 pt-6 pt-8 text-center"
      >
        <div class="text-4xl text-body-color">
          {{ Math.max.apply(null, gapDays).toLocaleString() }}
          <span class="text-xl uppercase">days</span>
        </div>
        <h4 class="text-2xs font-bold uppercase text-body-color">
          Duration of Longest Gap
        </h4>
      </div>
      <div
        class="flex flex-col items-center gap-4 rounded-md border border-yellow-500 p-4 pt-6 pt-8 text-center"
      >
        <div class="text-4xl text-body-color">
          {{
            $store.state.carriers?.showCarrierInspections
              ?.length_of_authority_in_months == 24
              ? '24+'
              : $store.state.carriers?.showCarrierInspections
                  ?.length_of_authority_in_months
          }}
          <span class="text-xl uppercase">mos</span>
        </div>
        <h4 class="text-2xs font-bold uppercase text-body-color">
          Current Length of Continuous Authority
        </h4>
      </div>
    </div>
    <div
      class="relative h-80 w-full flex-grow rounded-md border border-yellow-500 p-4 pb-6 pl-6"
    >
      <div
        class="absolute bottom-0 left-0 top-0 flex h-full w-6 items-center justify-center"
      >
        <div
          class="relative left-4 -rotate-90 transform whitespace-nowrap text-xs uppercase tracking-widest text-gray-over-dark"
        >
          Authority Coverage
        </div>
      </div>
      <div
        class="absolute bottom-0 left-0 right-0 flex h-6 w-full items-center justify-center"
      >
        <div
          class="whitespace-nowrap text-xs uppercase tracking-widest text-gray-over-dark"
        >
          Authority History Timeline
        </div>
      </div>
      <div
        ref="authorityHistoryInsightChartWrap"
        class="authority-history-insight-chart-wrap h-full w-full"
      >
        <line-chart-insights-authority-history
          v-if="chartData.length > 0"
          :width="chartWidth"
          :height="chartHeight"
          :plot-data="chartData"
          :chart-setup="chartSetup"
          :authority-history="hasAuthorityHistory"
        ></line-chart-insights-authority-history>
        <!-- <table class="bg-white relative z-40">
          <thead>
            <tr>
              <th>authority_type</th>
              <th>original_action</th>
              <th>original_action_date</th>
              <th>disposition_action</th>
              <th>disposition_date</th>
              <th>diff</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(h, index) in filterByAuthorityType(history, 'MOTOR PROPERTY CONTRACT CARRIER').reverse()" :key="'history-period-'+index">
              <td>{{ h.authority_type }}</td>
              <td>{{ h.original_action }}</td>
              <td>{{ h.original_action_date }}</td>
              <td>{{ h.disposition_action }}</td>
              <td>{{ h.disposition_date }}</td>
              <td>{{ daysDiff(h.disposition_date, h.original_action_date) }}</td>
            </tr>
          </tbody>
        </table> -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import LineChartInsightsAuthorityHistory from './LineChartInsightsAuthorityHistory.vue';

export default {
  name: 'AuthorityHistoryGapInsight',
  components: {
    LineChartInsightsAuthorityHistory,
  },
  props: {
    insight: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chartWidth: 0,
      chartHeight: 0,
      mounted: false,
      chartData: [],
      gapDataContract: [],
      gapDataCommon: [],
      gapDataBroker: [],
      gapDays: [0],
      currentAuthorityLengthInMonths: null,
      hasAuthorityHistory: {
        common: false,
        contract: false,
        broker: false,
      },
      top10Pct: 0,
      bottom10Pct: 0,
      limit: 5,
      history: [...this.$store.state.show.showBroker.authority.histories],
      chartXAxisLength: 0,
      chartYAxisLength: 0,
      authority_types: {
        common: [
          /* 'COMMON', */
          'HOUSEHOLD GOODS COMMON CARRIER',
          'MOTOR PASSENGER COMMON CARRIER',
          'MOTOR PROPERTY COMMON CARRIER',
          'PASSENGER REG ROUTE - COMMON',
          'WATER COMMON CARRIER',
        ],
        contract: [
          /* 'CONTRACT', */
          'HOUSEHOLD GOODS CONTRACT CARRIER',
          'MOTOR PASSENGER CONTRACT CARRIER',
          'MOTOR PROPERTY CONTRACT CARRIER',
          'WATER CONTRACT CARRIER',
        ],
        broker: [
          /* 'BROKER', */
          'HOUSEHOLD GOODS BROKER',
          'PROPERTY BROKER',
        ],
        other: [
          'EMERGENCY TEMPORARY AUTHORITY',
          'ENTERPRISE',
          'FOR HIRE EXEMPT PROPERTY',
          'FOR HIRE HOUSEHOLD GOODS',
          'FOR HIRE PROPERTY',
          'HOUSEHOLD GOODS FREIGHT FORWARDER',
          'PRIVATE CARRIER',
          'PROPERTY FREIGHT FORWARDER',
          'TEMPORARY AUTHORITY',
          'ENTERPRISE HOUSEHOLD GOODS',
        ],
      },
      chartSetup: {
        common: {
          y_val: 80,
        },
        contract: {
          y_val: 50,
        },
        broker: {
          y_val: 20,
        },
        chart_unit_height: 110,
        chart_unit_width: 0,
        y_label_offset: 10,
        x_axis_data: [],
        resizeObserver: null,
      },
    };
  },
  computed: {
    authorityColor() {
      var authority =
        this.$store.state.carriers?.showCarrierInspections
          ?.length_of_authority_in_months;
      if (authority > 15) {
        return 'text-green-500';
      } else if (authority > 6) {
        return 'text-orange-500';
      } else {
        return 'text-red-500';
      }
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.mounted = true;
    });
    this.resizeObserver = new ResizeObserver((entries) => {
      // We wrap it in requestAnimationFrame to avoid "ResizeObserver loop limit exceeded" error
      window.requestAnimationFrame(() => {
        if (!Array.isArray(entries) || !entries.length) {
          return;
        }
        this.resizeChart();
      });
    });
    this.resizeObserver.observe(this.$refs.authorityHistoryInsightChartWrap);
    // window.addEventListener("resize", this.resizeChart);
    this.resizeChart();
    this.generateAuthorityChartData(this.history);
  },
  beforeUnmount() {
    this.resizeObserver.unobserve(this.$refs.authorityHistoryInsightChartWrap);
    // window.removeEventListener('resize', this.resizeChart);
  },
  methods: {
    capitalizeWords: function (str) {
      return str
        .toLowerCase()
        .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())
        .replace('Llc', 'LLC');
    },
    resizeChart: function () {
      this.chartWidth =
        this.$refs.authorityHistoryInsightChartWrap?.clientWidth;
      this.chartHeight =
        this.$refs.authorityHistoryInsightChartWrap?.clientHeight;
    },
    initChart: function () {
      // this.chartData = this.safety.sms_basics.map((el) => ({
      //   name: this.displayMonthYear(el.file_date),
      //   pl: el.unsafe_driving_measure,
      // }));
    },
    calculateExpected: function (value) {
      var output = 0;

      value = parseInt(value);

      if (value == null) {
        return 0;
      }

      if (value > 60) {
        output = 200;
      } else if (value > 50) {
        output = 160 + (value - 50) * 4;
      } else if (value > 40) {
        output = 110 + (value - 40) * 5;
      } else if (value > 30) {
        output = 75 + (value - 30) * 3.5;
      } else if (value > 20) {
        output = 50 + (value - 20) * 2.5;
      } else if (value > 10) {
        output = 30 + (value - 10) * 2;
      } else {
        output = value * 3;
      }

      return output;
    },
    daysDiff: function (newerDateString, olderDateString) {
      var date1 = moment(newerDateString);
      var date2 = moment(olderDateString);
      var x = Math.round(moment.duration(date1.diff(date2)).asDays());
      return x;
    },
    monthsDiff: function (newerDateString, olderDateString) {
      var date1 = moment(newerDateString);
      var date2 = moment(olderDateString);
      return Math.round(moment.duration(date1.diff(date2)).asMonths());
    },
    yearsDiff: function (newerDateString, olderDateString, roundDown = false) {
      var date1 = moment(newerDateString);
      var date2 = moment(olderDateString);
      if (roundDown == true) {
        return Math.floor(moment.duration(date1.diff(date2)).asYears());
      }
      return Math.round(moment.duration(date1.diff(date2)).asYears());
    },
    filterByAuthorityType: function (history, aType) {
      var filteredHistory = history.filter((el) => {
        var matched = aType.includes(el.authority_type);
        // var matched = (aType == el.authority_type);
        return matched;
      });
      return filteredHistory;
    },
    generateAuthorityChartData: function (history) {
      var self = this;

      var initialCalcHistory = history.reverse();
      var startDate = '';
      var startDateFilled = false;
      initialCalcHistory.forEach(function (hist) {
        if (hist.original_action == 'GRANTED' && startDateFilled == false) {
          startDate = hist.original_action_date;
          startDateFilled = true;
        }
      });

      /* SET X-AXIS DATA */

      var todayDate = new Date();
      todayDate =
        todayDate.getFullYear() +
        '-' +
        String(todayDate.getMonth() + 1).padStart(2, '0') +
        '-' +
        String(todayDate.getDate()).padStart(2, '0');
      var dateSpan = this.yearsDiff(todayDate, startDate, true);

      var year = moment(startDate, 'YYYY-MM-DD').year();
      year = year + 1;
      var nextYearStart = year + '-01-01';
      var initialSpan = this.daysDiff(nextYearStart, startDate);

      var dateSpanLoop = dateSpan;
      var runningSpan = initialSpan;
      var runningYear = year;
      var divisor = 1;

      if (dateSpan >= 3) {
        if (dateSpan <= 13) {
          divisor = 1;
        } else if (dateSpan <= 26) {
          divisor = 2;
        } else if (dateSpan <= 39) {
          divisor = 3;
        } else if (dateSpan <= 52) {
          divisor = 4;
        }
        dateSpanLoop = dateSpanLoop / divisor;
        for (let idx = 0; idx < dateSpanLoop; idx++) {
          var objX = {};
          var objX2 = {};

          objX['name-x-label' + idx] = runningSpan.toString();
          objX['pl-x-label' + idx] = 0;
          objX['msg-x-label' + idx] = runningYear.toString();
          self.chartData.push(objX);

          objX2['nameX'] = runningSpan.toString();
          objX2['plX'] = 0;
          objX2['msgX'] = runningYear.toString();
          self.chartSetup.x_axis_data.push(objX2);

          var daysToAdd = 365 * divisor;
          for (let idx2 = 0; idx2 < divisor; idx2++) {
            if ((runningYear + idx2) % 4 == 0) {
              daysToAdd = daysToAdd + 1;
            }
          }

          runningSpan = runningSpan + daysToAdd;
          runningYear = runningYear + divisor;
        }
      }

      /* END SET X-AXIS DATA */

      var runningDays = 0;
      var i = 0;

      /* SET CONTRACT DATA */

      var historyDataContract = this.filterByAuthorityType(
        history,
        this.authority_types.contract
      ).reverse();
      if (historyDataContract.length > 0) {
        // console.dir(historyDataContract);

        var contractGrantedDate = '';
        var initialHistoryDataContract = historyDataContract;
        // initialHistoryDataContract = initialHistoryDataContract.reverse();

        // console.dir(initialHistoryDataContract);

        var initialContractGrantedDateFilled = false;
        initialHistoryDataContract.forEach(function (hist) {
          if (
            hist.original_action == 'GRANTED' &&
            initialContractGrantedDateFilled == false
          ) {
            contractGrantedDate = hist.original_action_date;
            initialContractGrantedDateFilled = true;
          }
        });

        if (contractGrantedDate.length > 0) {
          this.hasAuthorityHistory.contract = true;
          var latestContractValidDate = '';
          if (historyDataContract[0].disposition_date == null) {
            latestContractValidDate = todayDate;
          } else {
            latestContractValidDate = historyDataContract[0].disposition_date;
            this.currentAuthorityLengthInMonths = 0;
          }

          var fullContractSpan = this.daysDiff(
            latestContractValidDate,
            contractGrantedDate
          );

          this.chartData.push({
            name: '0',
            pl: self.chartSetup.contract.y_val,
          });
          this.chartData.push({
            name: fullContractSpan.toString(),
            pl: self.chartSetup.contract.y_val,
          });
          this.chartData.push({
            nameContract: '0',
            plContract: self.chartSetup.contract.y_val,
          });
          this.chartData.push({
            nameContract: fullContractSpan.toString(),
            plContract: self.chartSetup.contract.y_val,
          });
        }

        i = 0;
        runningDays = 0;
        historyDataContract = historyDataContract.reverse();
        // console.dir(historyDataContract);

        historyDataContract.forEach(function (h, index) {
          var dispositionDate = h.dispositionDate;
          if (dispositionDate == null) {
            dispositionDate = todayDate;
            var currentAuthorityLength = self.monthsDiff(
              dispositionDate,
              h.original_action_date
            );
            if (
              currentAuthorityLength < self.currentAuthorityLengthInMonths ||
              self.currentAuthorityLengthInMonths == null
            ) {
              self.currentAuthorityLengthInMonths = currentAuthorityLength;
            }
          }
          // var hLengthInDays = self.daysDiff(dispositionDate, h.original_action_date);

          if (index !== 0) {
            var hGapLength = self.daysDiff(
              h.original_action_date,
              historyDataContract[index - 1].disposition_date
            );
            runningDays = self.daysDiff(
              historyDataContract[index - 1].disposition_date,
              contractGrantedDate
            );
            if (hGapLength > 0) {
              // i += 1;
              var obj1 = {};
              obj1['name-gapContract' + i] = runningDays.toString();
              obj1['pl-gapContract' + i] = self.chartSetup.contract.y_val;
              var obj2 = {};
              obj2['name-gapContract' + i] = (
                runningDays + hGapLength
              ).toString();
              obj2['pl-gapContract' + i] = self.chartSetup.contract.y_val;
              self.gapDataContract.push([obj1, obj2]);
              self.chartData.push(obj1);
              self.chartData.push(obj2);
              // self.gapDataContract.push([{
              //   name2: runningDays.toString(),
              //   pl2: self.chartSetup.contract.y_val
              // },
              // {
              //   name2: (runningDays + hGapLength).toString(),
              //   pl2: self.chartSetup.contract.y_val
              // }]);
              var labelX = runningDays + hGapLength / 2;
              var obj3 = {};
              obj3['name-labelContract' + i] = labelX.toString();
              obj3['pl-labelContract' + i] = self.chartSetup.contract.y_val;
              obj3['msg-labelContract' + i] = hGapLength + ' days';
              self.chartData.push(obj3);
              self.gapDays.push(hGapLength);
              i = i + 1;
              runningDays = runningDays + hGapLength;
            }
          }
        });

        if (runningDays > this.chartSetup.chart_unit_width) {
          this.chartSetup.chart_unit_width = runningDays;
        }
      }

      /* END SET CONTRACT DATA */

      /* SET COMMON DATA */

      var historyDataCommon = this.filterByAuthorityType(
        history,
        this.authority_types.common
      ).reverse();
      if (historyDataCommon.length > 0) {
        // console.dir(historyDataCommon);

        var commonGrantedDate = '';
        var initialHistoryDataCommon = historyDataCommon;
        // initialHistoryDataCommon = initialHistoryDataCommon.reverse();

        // console.dir(initialHistoryDataCommon);

        var initialCommonGrantedDateFilled = false;
        initialHistoryDataCommon.forEach(function (hist) {
          if (
            hist.original_action == 'GRANTED' &&
            initialCommonGrantedDateFilled == false
          ) {
            commonGrantedDate = hist.original_action_date;
            initialCommonGrantedDateFilled = true;
          }
        });

        if (commonGrantedDate.length > 0) {
          this.hasAuthorityHistory.common = true;
          var latestCommonValidDate = '';
          if (historyDataCommon[0].disposition_date == null) {
            latestCommonValidDate = todayDate;
          } else {
            latestCommonValidDate = historyDataCommon[0].disposition_date;
            this.currentAuthorityLengthInMonths = 0;
          }
          var fullCommonSpan = this.daysDiff(
            latestCommonValidDate,
            commonGrantedDate
          );

          this.chartData.push({
            name: '0',
            pl: self.chartSetup.common.y_val,
          });
          this.chartData.push({
            name: fullCommonSpan.toString(),
            pl: self.chartSetup.common.y_val,
          });
          this.chartData.push({
            nameCommon: '0',
            plCommon: self.chartSetup.common.y_val,
          });
          this.chartData.push({
            nameCommon: fullCommonSpan.toString(),
            plCommon: self.chartSetup.common.y_val,
          });
        }

        i = 0;
        runningDays = 0;
        historyDataCommon = historyDataCommon.reverse();
        // console.dir(historyDataCommon);

        historyDataCommon.forEach(function (h, index) {
          var dispositionDate = h.dispositionDate;
          if (dispositionDate == null) {
            dispositionDate = todayDate;
            var currentAuthorityLength = self.monthsDiff(
              dispositionDate,
              h.original_action_date
            );
            if (
              currentAuthorityLength < self.currentAuthorityLengthInMonths ||
              self.currentAuthorityLengthInMonths == null
            ) {
              self.currentAuthorityLengthInMonths = currentAuthorityLength;
            }
          }
          // var hLengthInDays = self.daysDiff(dispositionDate, h.original_action_date);

          if (index !== 0) {
            var hGapLength = self.daysDiff(
              h.original_action_date,
              historyDataCommon[index - 1].disposition_date
            );
            runningDays = self.daysDiff(
              historyDataCommon[index - 1].disposition_date,
              commonGrantedDate
            );
            if (hGapLength > 0) {
              // i += 1;
              var obj1 = {};
              obj1['name-gapCommon' + i] = runningDays.toString();
              obj1['pl-gapCommon' + i] = self.chartSetup.common.y_val;
              var obj2 = {};
              obj2['name-gapCommon' + i] = (
                runningDays + hGapLength
              ).toString();
              obj2['pl-gapCommon' + i] = self.chartSetup.common.y_val;
              self.gapDataCommon.push([obj1, obj2]);
              self.chartData.push(obj1);
              self.chartData.push(obj2);
              // self.gapDataCommon.push([{
              //   name2: runningDays.toString(),
              //   pl2: self.chartSetup.common.y_val
              // },
              // {
              //   name2: (runningDays + hGapLength).toString(),
              //   pl2: self.chartSetup.common.y_val
              // }]);
              var labelX = runningDays + hGapLength / 2;
              var obj3 = {};
              obj3['name-labelCommon' + i] = labelX.toString();
              obj3['pl-labelCommon' + i] = self.chartSetup.common.y_val;
              obj3['msg-labelCommon' + i] = hGapLength + ' days';
              self.chartData.push(obj3);
              self.gapDays.push(hGapLength);
              i = i + 1;
              runningDays = runningDays + hGapLength;
            }
          }
        });

        if (runningDays > this.chartSetup.chart_unit_width) {
          this.chartSetup.chart_unit_width = runningDays;
        }
      }

      /* END SET COMMON DATA */

      /* SET BROKER DATA */

      var historyDataBroker = this.filterByAuthorityType(
        history,
        this.authority_types.broker
      ).reverse();
      if (historyDataBroker.length > 0) {
        // console.dir(historyDataBroker);

        var brokerGrantedDate = '';
        var initialHistoryDataBroker = historyDataBroker;
        // initialHistoryDataBroker = initialHistoryDataBroker.reverse();

        // console.dir(initialHistoryDataBroker);

        var initialBrokerGrantedDateFilled = false;
        initialHistoryDataBroker.forEach(function (hist) {
          if (
            hist.original_action == 'GRANTED' &&
            initialBrokerGrantedDateFilled == false
          ) {
            brokerGrantedDate = hist.original_action_date;
            initialBrokerGrantedDateFilled = true;
          }
        });

        if (brokerGrantedDate?.length > 0) {
          this.hasAuthorityHistory.broker = true;
          var latestBrokerValidDate = '';
          if (historyDataBroker[0].disposition_date == null) {
            latestBrokerValidDate = todayDate;
          } else {
            latestBrokerValidDate = historyDataBroker[0].disposition_date;
            this.currentAuthorityLengthInMonths = 0;
          }
          var fullBrokerSpan = this.daysDiff(
            latestBrokerValidDate,
            brokerGrantedDate
          );

          this.chartData.push({
            name: '0',
            pl: self.chartSetup.broker.y_val,
          });
          this.chartData.push({
            name: fullBrokerSpan.toString(),
            pl: self.chartSetup.broker.y_val,
          });
          this.chartData.push({
            nameBroker: '0',
            plBroker: self.chartSetup.broker.y_val,
          });
          this.chartData.push({
            nameBroker: fullBrokerSpan.toString(),
            plBroker: self.chartSetup.broker.y_val,
          });
        }

        i = 0;
        runningDays = 0;
        historyDataBroker = historyDataBroker.reverse();
        // console.dir(historyDataBroker);

        historyDataBroker.forEach(function (h, index) {
          var dispositionDate = h.dispositionDate;
          if (dispositionDate == null) {
            dispositionDate = todayDate;
            var currentAuthorityLength = self.monthsDiff(
              dispositionDate,
              h.original_action_date
            );
            if (
              currentAuthorityLength < self.currentAuthorityLengthInMonths ||
              self.currentAuthorityLengthInMonths == null
            ) {
              self.currentAuthorityLengthInMonths = currentAuthorityLength;
            }
          }
          // var hLengthInDays = self.daysDiff(dispositionDate, h.original_action_date);

          if (index !== 0) {
            var hGapLength = self.daysDiff(
              h.original_action_date,
              historyDataBroker[index - 1].disposition_date
            );
            runningDays = self.daysDiff(
              historyDataBroker[index - 1].disposition_date,
              brokerGrantedDate
            );
            if (hGapLength > 0) {
              // i += 1;
              var obj1 = {};
              obj1['name-gapBroker' + i] = runningDays.toString();
              obj1['pl-gapBroker' + i] = self.chartSetup.broker.y_val;
              var obj2 = {};
              obj2['name-gapBroker' + i] = (
                runningDays + hGapLength
              ).toString();
              obj2['pl-gapBroker' + i] = self.chartSetup.broker.y_val;
              self.gapDataBroker.push([obj1, obj2]);
              self.chartData.push(obj1);
              self.chartData.push(obj2);
              // self.gapDataBroker.push([{
              //   name2: runningDays.toString(),
              //   pl2: self.chartSetup.broker.y_val
              // },
              // {
              //   name2: (runningDays + hGapLength).toString(),
              //   pl2: self.chartSetup.broker.y_val
              // }]);
              var labelX = runningDays + hGapLength / 2;
              var obj3 = {};
              obj3['name-labelBroker' + i] = labelX.toString();
              obj3['pl-labelBroker' + i] = self.chartSetup.broker.y_val;
              obj3['msg-labelBroker' + i] = hGapLength + ' days';
              self.chartData.push(obj3);
              self.gapDays.push(hGapLength);
              i = i + 1;
              runningDays = runningDays + hGapLength;
            }
          }
        });

        if (runningDays > this.chartSetup.chart_unit_width) {
          this.chartSetup.chart_unit_width = runningDays;
        }
      }

      /* END SET BROKER DATA */

      this.chartData.push({
        x_axis_data: this.chartSetup.x_axis_data,
      });
      this.chartData.push({
        gapDataContract: this.gapDataContract,
        gapDataCommon: this.gapDataCommon,
        gapDataBroker: this.gapDataBroker,
      });
    },
  },
};
</script>
